import React, { useState } from "react";
import "./App.css";

import { BrowserRouter, Routes, Route } from "react-router-dom";

// Pages

import Home from "./pages/Home.js";
import About from "./pages/About.js";
import Contact from "./pages/Contact.js";
import FAQ from "./pages/FAQ.js";
import Governance from "./pages/Governance.js";
import Procedures from "./pages/Procedures.js";
import Providers from "./pages/Providers.js";
import Reports from "./pages/Reports.js";
import Navbar from "./components/Navbar";
import CorporateSocialResponsibility from "./pages/CorporateSocialResponsibility.js";

// About Pages

import Leadership from "./pages/about/Leadership";
import Main from "./pages/about/Main";
import MissionVision from "./pages/about/MissionVision";
import CompanyProfile from "./pages/about/CompanyProfile";
import CorporateIdentity from "./pages/about/CorporateIdentity";
import CertificateOfAuthority from "./pages/about/CertificateOfAuthority";
import CertificateOfRegistration from "./pages/about/CertificateOfRegistration.js";
import Branches from "./pages/about/Branches";
import CurriculumVitae from "./pages/about/CurriculumVitae.js";
import Committee from "./pages/about/Committee";

// Procedures Pages

import OutPatient from "./pages/procedures/OutPatient";
import InPatient from "./pages/procedures/InPatient";
import Emergency from "./pages/procedures/Emergency";
import Dental from "./pages/procedures/Dental";

// Providers Pages

import Hospitals from "./pages/providers/Hospitals";
import HospitalList from "./pages/providers/HospitalList";

// Leadership Lists

import BoardOfDirectors from "./pages/about/leadership/BoardOfDirectors";
import Management from "./pages/about/leadership/Management";

// Committee Lists

import AuditCommittee from "./pages/about/committee/AuditCommittee";
import CorporateGovernanceCommittee from "./pages/about/committee/CorporateGovernanceCommittee";
import BROC from "./pages/about/committee/BROC";
import RPTC from "./pages/about/committee/RPTC";
import SearchResults from "./pages/SearchResults";

// Components

import CustomToast from "./components/CustomToast";
import ErrorPage from "./pages/ErrorPage";
import CompanyPolicies from "./pages/about/CompanyPolicies.js";

function App() {
  require("dotenv").config();

  const [hospitalProps, setHospitalProps] = useState();
  const [searchProps, setSearchProps] = useState("");

  const [activateToast, setActivateToast] = useState(false);
  const [toastProps, setToastProps] = useState(null);

  const CustomToastContainer = ({ _isShown, setActivateToast, toastProps }) => {
    if (!_isShown) {
      return null;
    } else {
      return (
        <CustomToast
          _isShown={activateToast}
          setActivateToast={setActivateToast}
          toastProps={toastProps}
        />
      );
    }
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Navbar setSearchProps={setSearchProps} />
        <Routes>
          <Route
            exact
            path="/"
            element={
              <Home
                setActivateToast={setActivateToast}
                setToastProps={setToastProps}
              />
            }
          />
          <Route exact path="/about/" element={<About />}>
            <Route exact path="/about/" element={<Main />} />
            <Route exact path="leadership" element={<Leadership />}>
              <Route exact path="leadership" element={<BoardOfDirectors />} />
              <Route
                exact
                path="board-of-directors"
                element={<BoardOfDirectors />}
              />
              <Route exact path="management" element={<Management />} />
              <Route
              exact
              path="curriculum-vitae"
              element={<CurriculumVitae />}
              />
            </Route>
            <Route exact path="committee" element={<Committee />}>
              <Route exact path="committee" element={<AuditCommittee />} />
              <Route
                exact
                path="audit-committee"
                element={<AuditCommittee />}
              />
              <Route
                path="corporate-governance"
                element={<CorporateGovernanceCommittee />}
              />
              <Route exact path="board-risk-oversight" element={<BROC />} />
              <Route
                exact
                path="related-party-transactions"
                element={<RPTC />}
              />
            </Route>
            <Route
              exact
              path="mission-and-vision"
              element={<MissionVision />}
            />
            <Route exact path="company-profile" element={<CompanyProfile />} />
            <Route exact path="company-policies" element={<CompanyPolicies />} />
            <Route
              path="corporate-identity-and-values"
              element={<CorporateIdentity />}
            />
            <Route
              path="certificate-of-authority"
              element={<CertificateOfAuthority />}
            />
            <Route
              path="certificate-of-registration"
              element={<CertificateOfRegistration />}
            />
            <Route exact path="branches" element={<Branches />} />
          </Route>
          <Route
            exact
            path="/contact-us"
            element={
              <Contact
                setActivateToast={setActivateToast}
                setToastProps={setToastProps}
              />
            }
          />
          <Route
            path="/search"
            element={<SearchResults searchProps={searchProps} />}
          />
          <Route
            path="/corporate-social-responsibility"
            element={<CorporateSocialResponsibility />}
            // element={<ErrorPage />}
          />
          <Route exact path="/faq" element={<FAQ />} />
          <Route exact path="/governance" element={<Governance />} />
          <Route exact path="/procedures" element={<Procedures />}>
            <Route
              path="/procedures/emergency-availment"
              element={<Emergency />}
            />
            <Route
              path="/procedures/out-patient-availment"
              element={<OutPatient />}
            />
            <Route
              path="/procedures/in-patient-availment"
              element={<InPatient />}
            />
            <Route
              exact
              path="/procedures/dental-availment"
              element={<Dental />}
            />
          </Route>
          <Route exact path="/providers" element={<Providers />}></Route>
          <Route
            path="/providers/hospitals"
            element={
              <Hospitals
                setHospitalProps={setHospitalProps}
                providerType="H"
                providerTypeName="hospitals"
              />
            }
          />
          <Route
            path="/providers/hospitals/list"
            element={<HospitalList props={hospitalProps} />}
          />
          <Route
            exact
            path="/providers/clinics"
            element={
              <Hospitals
                setHospitalProps={setHospitalProps}
                providerType="C"
                providerTypeName="clinics"
              />
            }
          />
          <Route
            path="/providers/clinics/list"
            element={<HospitalList props={hospitalProps} />}
          />
          <Route
            exact
            path="/providers/dental"
            element={
              <Hospitals
                setHospitalProps={setHospitalProps}
                providerType="D"
                providerTypeName="dental"
              />
            }
          />
          <Route
            path="/providers/dental/list"
            element={<HospitalList props={hospitalProps} />}
          />
          <Route exact path="/reports" element={<Reports />} />
          <Route exact path="*" element={<ErrorPage />} />
          {/* <Route
            exact
            path='*'
            element={
              <h1
                style={{
                  position: "absolute",
                  height: "calc(100% - 75px)",
                  width: "100%",
                  transform: "translate(-50%, -50%)",
                  bottom: "-45%",
                  left: "50%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                Oops! The page you're trying to reach does not exist.
              </h1>
            }
          /> */}
        </Routes>
        <CustomToastContainer
          _isShown={activateToast}
          setActivateToast={setActivateToast}
          toastProps={toastProps}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
